import React, { FC } from 'react'

// style components
import Icon, { IconProps } from '../style/Icon.style'
import { useStyletron } from 'parkdepot-shared/theme'
import { Container, TextSection } from './NotificationSection.style'

interface Props {
    text: string
    backgroundColor?: string
    iconSize?: IconProps['$size']
}

const NotificationSection: FC<Props> = ({ text, backgroundColor = '#eff3fe', iconSize }) => {
    const [, theme] = useStyletron()
    return (
        <Container $backgroundColor={backgroundColor}>
            <Icon $size={iconSize} marginTop="4px" className="wemolo-info-circle" color={theme.colors.primary} />
            <TextSection>{text}</TextSection>
        </Container>
    )
}

export default NotificationSection
